import { useContext } from 'react';
import { uiContext } from '../context';

export const useUIContext = () => {
  const context = useContext(uiContext);
  if (!context) {
    throw new Error('useUIContext must be used inside UIProvider');
  }

  return context;
};
